import "../../styles/suite.scss";

/* tslint:disable */
export { cssManager } from "@dhx/ts-common/CssManager";
export { EventSystem } from "@dhx/ts-common/events";
export { awaitRedraw, resizeHandler } from "@dhx/ts-common/dom";
export { Uploader } from "@dhx/ts-vault";

export { Layout } from "@dhx/ts-layout";

export { List } from "@dhx/ts-list";
export { Calendar } from "@dhx/ts-calendar";
export { Colorpicker } from "@dhx/ts-colorpicker";
export { Chart } from "@dhx/ts-chart";
export { Combobox } from "@dhx/ts-combobox";
export { DataCollection, TreeCollection, DataProxy, dataDrivers, ajax } from "@dhx/ts-data";
export { DataView } from "@dhx/ts-dataview";
export { Form } from "@dhx/ts-form";
export { Grid } from "@dhx/ts-grid";
export { message, alert, confirm, enableTooltip, disableTooltip, tooltip } from "@dhx/ts-message";
export { Menu, ContextMenu } from "@dhx/ts-menu";
export { Popup } from "@dhx/ts-popup";
export { Ribbon } from "@dhx/ts-ribbon";
export { Sidebar } from "@dhx/ts-sidebar";
export { Slider } from "@dhx/ts-slider";
export { Tabbar } from "@dhx/ts-tabbar";
export { Timepicker } from "@dhx/ts-timepicker";
export { Toolbar } from "@dhx/ts-toolbar";
export { Tree } from "@dhx/ts-tree";
export { Window } from "@dhx/ts-window";

import { locale as colorpickerLocale } from "@dhx/ts-colorpicker";
import { default as messageLocale } from "@dhx/ts-message/sources/locales/en";
import { default as calendarLocale } from "@dhx/ts-calendar/sources/locales/en";
import { default as comboboxLocale } from "@dhx/ts-combobox/sources/locales/en";
import { default as formLocale } from "@dhx/ts-form/sources/locales/en";
import { default as timepickerLocale } from "@dhx/ts-timepicker/sources/locales/en";

const w = window as any;
export const i18n: any = (w.dhx && w.dhx.i18n) ? w.dhx.i18 : {};
i18n.setLocale = function (component: string, value: any) {
	const target = i18n[component];
	for (const key in value) {
		target[key] = value[key];
	}
};

i18n.colorpicker = i18n.colorpicker || colorpickerLocale;
i18n.message = i18n.message || messageLocale;
i18n.calendar = i18n.calendar || calendarLocale;
i18n.combobox = i18n.combobox || comboboxLocale;
i18n.form = i18n.form || formLocale;
i18n.timepicker = i18n.timepicker || timepickerLocale;

